const img = require('./Fortmatic.svg'); export default img;